import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkOrderLocationComponent } from './work-order-location.component';
import { CtModelModule } from '@ctsolution/ct-framework';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    CtModelModule,
    TranslateModule
  ],
  declarations: [WorkOrderLocationComponent],
  exports : [WorkOrderLocationComponent]
})
export class WorkOrderLocationModule { }
